import { Link, NavLink } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import logo2 from "../assets/logo2.png";
import { faBars } from "@fortawesome/free-solid-svg-icons";

export default function Header() {
  return (
    <div class="header-area">
      <nav class="navbar navbar-expand-md p-3">
        <Link className="navbar-brand logoLink" to="/">
          <img src={logo2} alt="logo" className="mainLogo" />
        </Link>
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#Navbar"
        >
          <span>
            <FontAwesomeIcon icon={faBars} />
          </span>
        </button>

        <div
          class="collapse navbar-collapse justify-content-end align-items-end  mb-0 navbar-menu"
          id="Navbar"
        >
          <ul class="navbar-nav mr-auto">
            <li class="nav-item active">
              <NavLink className="nav-link" to="/about-us">
                About us
              </NavLink>
            </li>

            <li class="nav-item active">
              <NavLink className="nav-link" to="/privacy-policy">
                Privacy Policy
              </NavLink>
            </li>

            <li class="nav-item">
              <Link className="nav-link " to="/terms-of-use">
                Terms Of Use
              </Link>
              {/* <span class="badge bg-info">New</span> */}
            </li>
            {/* <li class="nav-item dropdown">
              <a
                class="nav-link "
                href="#"
                id="navbarDropdown"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                more.
              </a>
              <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                <Link class="dropdown-item" to="/learn">
                  Learn
                </Link>
                <Link class="dropdown-item" to="/mutual-funds">
                  Mutual Funds
                </Link>
                <a class="dropdown-item" href="#">
                  ETF's
                </a>
                <a class="dropdown-item" href="#">
                  Digi Gold/SGB
                </a>
                <a class="dropdown-item" href="#">
                  PPF/NPS
                </a>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" href="#">
                  Crypto
                </a>
              </div>
            </li> */}
          </ul>
          {/* <Link class="earn-btn" data-scroll-nav="1" to="/premium">
            Premium
          </Link> */}
          {/* <a href="#" data-scroll-nav="1" class="earn-btn">Earn with Us</a>
           */}
        </div>
      </nav>
    </div>
  );
}
